import React from 'react';
import Switch from '@mui/material/Switch';
import Styles from '../../../Css/View360/View360.module.css';
import { useDispatch } from 'react-redux';
import { setToggleInteriorHotspot } from '../../../Redux/Reducers/View360Reducer/View360ActionController';

const HotspotVisibilityComponent = ({isSpanish, handlerMobileHotspot, setHandlerMobileHotspot, toggleHotspotVisibility,ToggleInteriorHotspots }) => {
    const dispatch = useDispatch();
    const handleToggleChange = () => {
    setHandlerMobileHotspot(prev => !prev);
    dispatch(setToggleInteriorHotspot(!ToggleInteriorHotspots));
  };

  return (
    <div className={Styles['hotspot-info-tag-left-mobile-view']} style={{ right: isSpanish ? '1%' : 0 }}>
      <span className='text-[14px] right font-inter font-medium' style={{color:'black'}}>
        {isSpanish ? 'Puntos de acceso' : 'Hotspots'}
      </span>
      <Switch
        onChange={handleToggleChange}
        checked={ToggleInteriorHotspots}
        sx={{
          '& .MuiSwitch-thumb': {
            backgroundColor: '#4600F2',
          },
        }}
        className={Styles["customSwitchTrack"]}
      />
    </div>
  );
};

export default HotspotVisibilityComponent;